var themeObject="idm-theme-blue"
/**
 * 获取当前应用主题信息
 */
function getCurrentThemeInfo(){
    return this.themeObject;
}
/**
 * 设置当前应用主题信息
 * @param {*} object 
 */
function setCurrentThemeInfo(object){
    this.themeObject = object;
    //追加之前先删除
    var classList = $("body").attr("class");
    if(classList){
        classList = classList.split(" ");
        var newClassNames = []
        classList.forEach(element => {
            if(!element.startsWiths(IDM.setting.applications.themeNamePrefix)){
                newClassNames.push(element)
            }
        });
        $("body").attr("class",newClassNames.join(" "));
    }
    //给body追加class
    $("body").addClass(IDM.setting.applications.themeNamePrefix+(typeof object==="object"?JSON.stringify(object):object));
}

export default {
    getCurrentThemeInfo,
    setCurrentThemeInfo,
    themeObject:themeObject
}